import { constants, mediaQueryStyles } from "@newsela/angelou";

const { mediaQuery: mq } = mediaQueryStyles;
const {
  BreakpointNames: { xs, sm },
} = constants.breakpoints;
const { ui } = constants.colors;

const white = ui.white[500];

export const containerWrapper = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  position: "absolute",
  top: "-54px",
  borderTopRightRadius: "24px",
  borderTopLeftRadius: "24px",
  backgroundColor: white,
  padding: "4px 20px 8px 4px",

  [mq.downTo(xs)]: {
    top: "-50px",
  },

  [mq.downTo(sm)]: {
    top: "-57px",
  },
};

export const containerCss = {
  display: "flex",
  flexDirection: "row",
  alignItems: "flex-start",
  padding: "4px",
  borderRadius: "40px",
};
